export default "__VITE_PUBLIC_ASSET__507c91e1__"